import { memo } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import QuizIcon from "@mui/icons-material/Quiz";

import SideBorderCard from "src-next/shared/ui/cards/SideBorderCard";
import type { QuestionnaireSummary } from "../types";

export interface QuestionnairesCardsSectionProps {
  questionnaires: QuestionnaireSummary[];
}

const QuestionnairesCardsSection = memo(
  ({ questionnaires }: QuestionnairesCardsSectionProps) => {
    return (
      <Box
        sx={{
          display: "grid",
          gap: 1.5,
          gridTemplateColumns: {
            xs: "1fr",
            md: "repeat(2, minmax(0, 1fr))",
          },
        }}
      >
        {questionnaires.map((questionnaire) => (
          <SideBorderCard key={questionnaire.id} borderColor="secondary.main">
            <Stack direction="row" spacing={1.25} alignItems="center">
              <Box
                sx={{
                  width: 36,
                  height: 36,
                  borderRadius: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  bgcolor: "secondary.50",
                  color: "secondary.main",
                  flexShrink: 0,
                }}
              >
                <QuizIcon fontSize="small" />
              </Box>
              <Box sx={{ minWidth: 0 }}>
                <Typography variant="subtitle2" fontWeight={800}>
                  {questionnaire.title}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    mt: 0.25,
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                >
                  {questionnaire.description}
                </Typography>
              </Box>
            </Stack>
          </SideBorderCard>
        ))}
      </Box>
    );
  },
);

QuestionnairesCardsSection.displayName = "QuestionnairesCardsSection";

export default QuestionnairesCardsSection;
